<template>
  <el-tooltip placement="top">
    <div slot="content">{{ label }}</div>
    <el-button class="myStyle"   size="mini" @click="click" :disabled="disabled">
      <img v-if="!!iconUrl" :src="iconUrl" :alt="label"/>
      <i v-if="!!iconClass" :class="iconClass"></i>
    </el-button>
  </el-tooltip>
</template>

<script>
  export default {
    name: "canvas-tool-button",
    props: ["label", "iconClass", "iconUrl", "disabled"],
    methods: {
      click() {
        this.$emit('click');
      }
    }
  };
</script>

<style scoped>
.myStyle{
  padding: 9px 14px;

}
</style>



// WEBPACK FOOTER //
// src/views/common/noteDocs/canvas-tool-button.vue